import { createButtonListSetters } from '@/common/manager/button';
import { ButtonPosition } from '@/type/button-position';

export default function () {
  return {
    name: 'buttons',
    title: '操作列',
    display: 'accordion',
    // collapsed:false,
    initialValue: [
      {
        children: '按钮',
        primaryKey: '123',
      },
    ],
    // supportVariable: true,
    setter: createButtonListSetters({
      position: ButtonPosition.tableOperate,
      childrenTitle: '操作文案',
      additionalPosition: ButtonPosition.childTableOperate,
    }),
  };
}
